export class ConfBlock {
  constructor(id, deps, isVisible, isDefault) {
    if (!id) {
      throw new Error('ID NEEDED');
    } else {
      this.id = id;
      if (deps) {
        this.deps = deps;
      }
      this.isVisible = isVisible ?? true;
      this.isDefault = isDefault ?? true;
    }
  }

  setV(bool) {
    return new ConfBlock(this.id, this.deps, bool, this.isDefault);
  }

  setD(bool) {
    return new ConfBlock(this.id, this.deps, this.isVisible, bool);
  }

  setVD(bool) {
    return new ConfBlock(this.id, this.deps, bool, bool);
  }
}

export default ConfBlock;
